export enum LookupAppointmentRequiredFieldEnum {
    NumeroDaGuiaOperadora = 1,
    ValidadeDaCarteira = 2,
    Justificativa = 3,
    CoberturaEspecial = 4,
    SaudeOperacional = 5
}